module.exports = __webpack_public_path__ + "img/footprint-arch-high.da2028de.svg";